import { useCallback, useMemo, useRef, useState } from 'react';

import { useOutsideAlerter } from '../transcript/useClickOutside';

interface UseDropdownOptions {
  resetQueryOnClose?: boolean;
}

export function useDropdown({
  resetQueryOnClose = false,
}: UseDropdownOptions = {}) {
  const dropdownRef = useRef<HTMLDivElement>(null);
  const [isOpen, setIsOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');

  const close = useCallback(() => {
    if (!isOpen) return;
    setIsOpen(false);
    if (resetQueryOnClose) {
      setSearchQuery('');
    }
  }, [isOpen, resetQueryOnClose]);

  const toggle = useCallback(() => {
    setIsOpen(prev => !prev);
  }, []);

  useOutsideAlerter(
    dropdownRef,
    useMemo(
      () => () => {
        if (isOpen) close();
      },
      [close, isOpen],
    ),
  );

  return {
    dropdownRef,
    isOpen,
    toggle,
    close,
    searchQuery,
    setSearchQuery,
  };
}

export type ReturnTypeUseDropdown = ReturnType<typeof useDropdown>;
